<template>
  <div>
    <div style="display: flex; align-items: flex-end; flex-direction: row;
      justify-content: space-between; align-items: flex-end">
      <div  v-for="idx in ranges[0]" :key="idx"
              :style="`width: ${(100/ranges[0].length)-2}%;
                margin-right: 1%`">
        <div :style="`background-color: ${textColor}; max-width: 250px;
                  padding: 10px; margin-right: 1%; border-radius: 5px;
                  color: ${backgroundColor}; font-size: 0.9em;
                  box-shadow: 5px 5px 8px rgba(100, 100, 100, 0.5);`">
          <span style="font-family: 'Hammersmith One', sans-serif; font-weight: bold">
            {{ events[idx].date }}
          </span> <br>
          {{ events[idx].content }}
        </div>
      </div>
    </div>
    
    <div style="width: 100%; height: 6px; display: flex; flex-direction: row; align-items: center; margin-bottom: 15px; justify-content: space-evenly;">
      <div v-for="(e, idx) in events" :key="idx">
        <i class="fas icon-fa-caret-down" :style="`color: ${alternateColors[((idx+1)%2)]}; opacity: ${alternateOpacity[((idx+1)%2)]}; font-size: 30px`"></i>
      </div>
    </div>

    <div :style="`width: 100%; height: 2px; background-color: ${textColor}; display: flex; flex-direction: row; align-items: center; justify-content: space-evenly`">
      <div v-for="(e, idx) in events" :key="idx">
        <i class="fas icon-fa-circle" :style="`color: ${textColor}`"></i>
      </div>
    </div>

    <div style="width: 100%; height: 6px; display: flex; flex-direction: row; align-items: center; margin-top: 15px; justify-content: space-evenly">
      <div v-for="(e, idx) in events" :key="idx">
        <i class="fas icon-fa-caret-up" :style="`color: ${alternateColors[idx%2]}; font-size: 30px`"></i>
      </div>
    </div>

    <el-row justify="space-between">
      <el-col  v-for="idx in ranges[1]" :key="idx"
              :style="`width: ${(100/ranges[0].length)-2}%;
                margin-right: 1%;`">
        <div
          :style="`background-color: ${textColor}; max-width: 250px;
                  padding: 10px; margin-right: 1%; border-radius: 5px; 
                  color: ${backgroundColor}; font-size: 0.9em; float: right;
                  box-shadow: 5px 5px 8px rgba(100, 100, 100, 0.5);`">
          <span style="font-family: 'Hammersmith One', sans-serif; font-weight: bold">{{ events[idx].date }}</span> <br>
          {{ events[idx].content }}
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { store } from '@/scripts/store.js';
  const _ = require('lodash');
  
  export default {
    name: 'TimelineEvents',
    props: { },
    components: { },
    data() {
      return {
        store: store,
        events: [
          {
            date: 'Dec 2019',
            content: 'First confirmed case of SARS-CoV-2 infection in the world'
          },
          {
            date: 'Sept 5 2020',
            content: '1000 SARS-CoV-2 genomes sequenced in India'
          },
          {
            date: '27th Jan 2020',
            content: 'First confirmed case of SARS-CoV-2 infection in India'
          },
          {
            date: '29th Feb 2020',
            content: 'First genome of SARS-CoV-2 sequenced in India'
          },
          {
            date: 'March 1st 2020',
            content: 'I/A3i genome is reported'
          },
          {
            date: '5th Jan 2020',
            content: 'First genome of SARS-CoV-2 sequenced'
          },
        ]
      }
    },
    computed: {
      backgroundColor() {
        return store.theme.viewMode.backgroundColor[store.theme.viewMode.active]
      },
      textColor() {
        return store.theme.viewMode.textColor[store.theme.viewMode.active]
      },
      alternateColors() {
        return [
          store.theme.viewMode.backgroundColor[store.theme.viewMode.active],
          store.theme.viewMode.textColor[store.theme.viewMode.active]
        ]
      },
      alternateOpacity() {
        return [0, 1]
      },
      tooltipBackground() {
        return store.theme.viewMode.tooltipBackgroundColor[store.theme.viewMode.active]
      },
      ranges() {
        const events = this.events
        console.log(events.length)
        let range1 = []
        let range2 = []
        if (events.length % 2 === 1) {
          range1 = _.range(0, events.length, 2)
          range2 = _.range(events.length-2, 0, -2)
        } else {
          range1 = _.range(0, events.length, 2)
          range2 = _.range(events.length-1, 0, -2)
        }
        return [ range1, range2 ]
      }
    },
    methods: {    }
  }
</script>

<style scoped>

</style>
